/*
 * @Author: aalizzwell
 * @Date: 2019-05-30 10:35:09
 * @Last Modified by: aalizzwell
 * @Last Modified time: 2019-06-15 19:22:13
 */
import { Injectable, Optional } from '@angular/core';
import { LanguageService } from './languag.service';
import { FormErrorService } from './error/form-error.service';
import { IExceptionHandler, AppContext } from '@farris/devkit';

/**
 * é»è®¤å¼å¸¸å¤çå¨
 * @scope æ²¡ææä¾å¯¹åºProvider
 */
@Injectable()
class ExceptionHandler implements IExceptionHandler {
  private appContext: AppContext = null;
  constructor(
    private formErrorService: FormErrorService,
    @Optional() private languageService: LanguageService,
    private applicationContext: AppContext,
  ) {
    if (this.languageService == null) {
      this.languageService = LanguageService.getInstance();
    }
  }
  public setContext(applicationContext: AppContext) {
    this.appContext = applicationContext;
  }
  public handle(error: any) {
    if (!!this.formErrorService) {
      this.formErrorService.exception(this.languageService.loadFailed, error);
    }
  }
}

export { ExceptionHandler };
